import React from 'react';
import './Certificates.css';

const Certificates = () => {
  const certificates = [
    {
      name: 'Full Stack Web Development Bootcamp',
      issuer: 'Udemy',
      year: '2025',
      description: 'Completed an intensive full-stack program focused on HTML, CSS, Javascript, Node, React, PostgreSQL, Web3 and DApps.',
      file: '/certificate-bootcamp.pdf'
    },

    {
      name: 'Povio Academy Conference',
      issuer: 'Povio',
      year: '2025',
      description: 'Participated and expanded IT expertise at the Povio Academy Conference 2025.',
      file: '/povio.pdf'
    }
    /*
    {
      name: 'Microsoft Azure Developer Associate (AZ-204)',
      issuer: 'Microsoft',
      year: '2026',
      description: 'Certified in building, deploying and maintaining cloud applications using Azure services, with strong skills in cloud development and automation.',
      file: '#'
    }, */
  ];

  return (
    <section className="certificates" id="certificates">
      <div className="certificates-container">
        <div className="section-header">
          <h2 className="section-title pink-bg">CERTIFICATES</h2>
        </div>

        <div className="certificates-grid">
          {certificates.map((cert, index) => (
            <div key={index} className="certificate-card">
              <div className="certificate-badge">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#ff1493" strokeWidth="2">
                  <path d="M12 15l-3 3v-8l3-3 3 3v8z"/>
                  <circle cx="12" cy="8" r="7"/>
                </svg>
              </div>
              <h3 className="certificate-name">{cert.name}</h3>
              <div className="certificate-issuer">{cert.issuer}</div>
              <div className="certificate-year">{cert.year}</div>
              <p className="certificate-description">{cert.description}</p>

              <a href={cert.file} download className="cv-download-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="7 10 12 15 17 10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
                  Download Certificate
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificates;